import React from 'react';
import LegalLayout from '../components/LegalLayout';

const emailAddress = String.fromCharCode(
  115, 105, 100, 101, 64, 101, 99, 111, 109, 99, 111, 100, 101, 108, 97, 98, 46, 100, 101
);

const Datenschutz = () => {
  return (
    <LegalLayout title="Datenschutzerklärung">
      <div className="space-y-6">
        <div className="bg-success/10 border border-success/20 p-6 rounded-xl">
          <h3 className="text-success font-bold mb-2 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-success"></span>
            Cookieless & Private
          </h3>
          <p className="text-textMuted text-sm leading-relaxed">
            Diese Webseite nutzt <strong>keine Cookies</strong>, <strong>kein Tracking</strong> und <strong>keine externen APIs</strong> (wie Supabase oder Google Fonts). Alle Daten bleiben lokal in Ihrem Browser.
          </p>
        </div>

        <div className="p-6 bg-cardBg rounded-xl border border-borderDark text-sm">
          <strong className="text-textMain block mb-2 underline">Verantwortlicher:</strong>
          <p className="text-textMuted">
            ecomcodelab | Billy Kittler<br/>
            Demminer Str 17, 13059 Berlin<br/>
            E-Mail: <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
          </p>
        </div>

        <h2 className="text-xl font-bold text-textMain mt-8">1. Datenerhebung</h2>
        <p className="text-textMuted">
          Wir erheben keine personenbezogenen Daten beim Besuch dieser Webseite. Es werden keine Server-Logfiles gespeichert, die Ihre IP-Adresse enthalten könnten.
        </p>

        <h2 className="text-xl font-bold text-textMain mt-8">2. Browser-Erweiterung</h2>
        <p className="text-textMuted">
          Die Browser-Erweiterung funktioniert autark. Passwörter werden mittels lokaler Verschlüsselung (AES) ausschließlich in Ihrem Browser-Profil gespeichert. Es findet keine Synchronisation mit externen Cloud-Diensten statt.
        </p>

        <p className="mt-12 text-xs text-textMuted/50 italic">Stand: Februar 2024</p>
      </div>
    </LegalLayout>
  );
};

export default Datenschutz;